export const ticketTypes = {
    PAST: 'PAST',
    PRESENT: 'PRESENT',
};
